const communities = [
  { name: "East Grand Forks, MN", zip: "56721" },
  { name: "Thompson", zip: "58278" },
  { name: "Emerado", zip: "58228" },
  { name: "Larimore", zip: "58251" },
  { name: "Northwood", zip: "58267" },
  { name: "Crookston, MN", zip: "56716" },
  { name: "Grafton", zip: "58237" },
  { name: "Park River", zip: "58270" },
];

export default function LocalAreaSection() {
  return (
    <section id="service-area" className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-14 items-center">
          <div>
            <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Service Area</p>
            <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-5">
              Serving Grand Forks and the University Region
            </h2>
            <p className="text-gray-500 text-base leading-relaxed mb-6">
              Fast Passport Center serves all Grand Forks residents, University of North Dakota students and faculty, and the surrounding Grand Forks County area. As a border city straddling North Dakota and Minnesota, Grand Forks has unique passport needs — from international student travel to cross-border commuters. Our courier network covers the entire northeastern ND region including the twin city of East Grand Forks.
            </p>
            <div className="bg-white border border-gray-200 rounded-lg p-6 mb-6">
              <h3 className="font-bold text-[#1A365D] text-sm mb-3">Nearest Regional Passport Agency</h3>
              <p className="text-gray-500 text-sm leading-relaxed">
                The Chicago Passport Agency (230 S. Dearborn St) is approximately <strong className="text-[#1A365D]">580+ miles</strong> from Grand Forks. The twin cities Minneapolis agency is about 330 miles south. Both require advance appointments for genuine emergencies. Fast Passport Center handles everything remotely — no long drive required.
              </p>
            </div>
            <div className="flex flex-wrap gap-3">
              <div className="flex items-center gap-2 bg-white border border-gray-200 rounded-md px-3 py-2">
                <i className="ri-map-pin-line text-[#F6C344]"></i>
                <span className="text-sm text-[#1A365D] font-medium">Grand Forks, ND 58201</span>
              </div>
              <div className="flex items-center gap-2 bg-white border border-gray-200 rounded-md px-3 py-2">
                <i className="ri-map-pin-line text-[#F6C344]"></i>
                <span className="text-sm text-[#1A365D] font-medium">East Grand Forks, MN</span>
              </div>
              <div className="flex items-center gap-2 bg-white border border-gray-200 rounded-md px-3 py-2">
                <i className="ri-map-pin-line text-[#F6C344]"></i>
                <span className="text-sm text-[#1A365D] font-medium">Thompson, ND 58278</span>
              </div>
            </div>
          </div>
          <div>
            <h3 className="font-bold text-[#1A365D] text-base mb-4">Communities We Serve</h3>
            <div className="grid grid-cols-2 gap-3">
              {communities.map((c, i) => (
                <div key={i} className="bg-white border border-gray-200 rounded-md px-4 py-3 flex items-center justify-between">
                  <span className="text-sm font-medium text-[#1A365D]">{c.name}</span>
                  <span className="text-xs text-gray-400">{c.zip}</span>
                </div>
              ))}
            </div>
            <div className="mt-6 bg-[#1A365D] rounded-lg p-5">
              <h4 className="font-bold text-white text-sm mb-2">Grand Forks International Airport (GFK)</h4>
              <p className="text-white/60 text-sm leading-relaxed">
                Grand Forks Airport connects to Minneapolis and Chicago, giving travelers access to hundreds of international connections. UND students, research professionals, and business travelers rely on Fast Passport Center to have their documents ready without a drive to a distant regional agency.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}